const validate = (editorState) => {
  const result = [];

  if (!editorState.firstName) {
    result.push({
      param: 'firstName',
      userMessage: 'Pole wymagane',
    });
  }

  if (!editorState.lastName) {
    result.push({
      param: 'lastName',
      userMessage: 'Pole wymagane',
    });
  }

  if (editorState.phone) {
    // eslint-disable-next-line no-useless-escape
    const phoneValidation = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
    const phoneValidationResult = phoneValidation.test(String(editorState.phone).toLowerCase());

    if (!phoneValidationResult) {
      result.push({
        param: 'phone',
        userMessage: 'Numer telefonu jest nieprawidłowy',
      });
    }
  }

  if (editorState.mobilePhone) {
    // eslint-disable-next-line no-useless-escape
    const mobilePhoneValidation = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
    const mobilePhoneValidationResult = mobilePhoneValidation.test(String(editorState.mobilePhone).toLowerCase());

    if (!mobilePhoneValidationResult) {
      result.push({
        param: 'mobilephone',
        userMessage: 'Numer telefonu jest nieprawidłowy',
      });
    }
  }

  if (editorState.password && editorState.repeatpassword && !editorState.currentPassword) {
    result.push({
      param: 'currentPassword',
      userMessage: 'Pole wymagane',
    });
  }

  if ((editorState.password || editorState.repeatpassword) && editorState.password !== editorState.repeatpassword) {
    result.push({
      param: 'repeatpassword',
      userMessage: 'Hasła nie są identyczne',
    });
  }

  return result.length > 0 ? result : null;
};

export default validate;
